import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@klear/ui/lib/utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline: 'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline'
      },
      size: {
        default: 'h-9 px-4 py-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        xs: 'h-6 rounded-md px-2 text-xs',
        lg: 'h-10 rounded-md px-8',
        icon: 'h-9 w-9'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

type RouterLinkProps = {
  to: string
  className?: string
  children?: React.ReactNode
  ref?: React.Ref<HTMLAnchorElement>
}

export interface ButtonLinkProps extends VariantProps<typeof buttonVariants>, RouterLinkProps {
  Link: (props: RouterLinkProps) => React.ReactNode
}

const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ Link, className, variant, size, ...props }, ref) => {
    return <Link className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
  }
)
ButtonLink.displayName = 'ButtonLink'

export { ButtonLink, buttonVariants }
